import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";

function LodegmentSubDetailForm({ lodgementStatus, transHeadId }) {
    const [loading, setloading] = useState(false);

    const validationSchema = Yup.object().shape({
        lodgementReason: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            lodgementReason: "",
        },
        onSubmit: async (data) => {
            setloading(true);
            data["lodgementStatus"] = lodgementStatus;
            data["transHeadIds"] = transHeadId;
            await handlePostRequest(data, "zbizgateway/fin/collection/updateLodgment");
            setloading(false);
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>{lodgementStatus === "A" ? "Approve" : "Reject"} Lodgment</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-field">
                                <label htmlFor="lodgementReason" className={classNames({ "p-error": isFormFieldValid("lodgementReason") }, "Label__Text")}>
                                    Reason<span className="Label__Required">*</span>
                                </label>

                                <InputTextarea
                                    placeholder="Add Reason"
                                    id="lodgementReason"
                                    name="lodgementReason"
                                    value={formik.values.lodgementReason}
                                    rows={5}
                                    cols={10}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("lodgementReason") }, "TextArea__Round")}
                                />

                                {getFormErrorMessage("lodgementReason")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} type="submit" label="Ok" className="Btn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default LodegmentSubDetailForm;
